
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coding-for-kids",
      function () {
        return require("private-next-pages/coding-for-kids.tsx");
      }
    ]);
  